import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { queryParamSelector, RouterAction } from '@cbridge-packages/routing';
import { SymbolGroupsAction } from '../symbolGroups.action';
import { SymbolGroupParam } from '../_helpers/symbolGroupSearchParam';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>;

export const toggleSelectSymbolGroupEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolGroupsAction.toggleSelect),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { symbolGroup } = payload;
    const currentGroup = queryParamSelector(state, SymbolGroupParam.name);

    if (symbolGroup === currentGroup) {
      return [
        RouterAction.removeParam(SymbolGroupParam.name),
      ];
    }
    return [
      RouterAction.addParam(SymbolGroupParam.nameAndValue(symbolGroup)),
    ];
  }),
);
